function LoadingBasic(props) {

  const wording = props.wording || "Loading ...";

  return (
    <div class='loading-general'>
      <div class='button is-loading'></div>
      <p>{wording}</p>
    </div>
  );
};

export default LoadingBasic;